// TODO: why do we need an object literal here instead directly using title value
export function sortByTitle(a: { title: string }, b: { title: string }): number {
  if (a.title < b.title) { return -1; }
  if (a.title > b.title) { return 1; }

  return 0;
}
